module.exports = __webpack_public_path__ + "images/home-healthtech.jpg?a6604e7";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/home-healthtech.jpg
// module id = 337
// module chunks = 0